import React from "react";
import styled from "@emotion/styled";
import "bootstrap/dist/css/bootstrap.min.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "react-h5-audio-player/lib/styles.css";
import useSound from "use-sound";
import {
  Alert as MuiAlert,
  Box,
  Grid,
  TextField as MuiTextField,
  Divider as MuiDivider,
  Popover as MuiPopover,
  LinearProgress as MuiLinearProgress,
} from "@mui/material";
//import HelpIcon from "@mui/icons-material/Help";
import { spacing } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
//import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import AttachmentIcon from "@mui/icons-material/Attachment";
import Button from "@mui/material/Button";
import ChatMessageComponent from "./ChatMessageComponent";
import { useDispatch, useSelector } from "react-redux";
import EmojiPicker from "emoji-picker-react";

import {
  uploadFileData,
  uploadPrivateFileData,
} from "../../../../redux/slices/chatSettings";
import { fetchAllCannedResponses } from "../../../../redux/slices/cannedResponses";
import { fetchTodayschat } from "../../../../redux/slices/socketsSlice";
//import { yellow } from "@mui/material/colors";
import ChatInputComponent from "./chatInputs/ChatInputComponent";

const Divider = styled(MuiDivider)(spacing);
const TextField = styled(MuiTextField)(spacing);
const LinearProgress = styled(MuiLinearProgress)(spacing);
const timeOut = (time) => new Promise((res) => setTimeout(res, time));
const Alert = styled(MuiAlert)(spacing);
//console.log("sendingSound == ", sendingSound);
const Popover = styled(MuiPopover)`
  .MuiPaper-root {
    width: 300px;
    ${(props) => props.theme.shadows[1]};
    border: 1px solid ${(props) => props.theme.palette.divider};
  }
`;

const ChatMessages = styled.div`
  overflow-y: scroll;
  background-color: rgba(255, 255, 255, 0.6);
  flex-direction: "column";
  gap: 2;
  background-image: url(/static/img/samples/fbe41cd97ada760e7b38de1be18301a5.jpg);
  background-size: 10%;
  background-blend-mode: overlay;
  background-attachment: fixed;
  height: calc(-35px + 68vh);
  overflowy: auto;
  //border: 1px solid #ccc;
  border-radius: 5px;
`;

const ChatInput = styled(Grid)`
  max-height: 60px;
  padding: ${(props) => props.theme.spacing(5)};
`;

const ChatActionNote = styled(`span`)`
  background-color: ${(props) => props.theme.sidebar.header.chipNote.color};
  padding: ${(props) => props.theme.spacing(2)};
  border-radius: 10px;
  margin-right: 20px;
  cursor: pointer;
`;

const ChatMessagePannel = ({ socket }) => {
  //const [notificationSPlay] = useSound(notificationSound);
  const dispatch = useDispatch();
  //const bottomRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const bottomRef = React.useRef(null);
  const [isAtBottom, setIsAtBottom] = React.useState(true);
  //const [sendingPlay] = useSound(sendingSound);
  const [sendingPlay] = useSound(
    "https://liveagentapp-in.s3.ap-south-1.amazonaws.com/uploads/1720614091715_new-notification-7-210334.mp3"
  );
  const [key, setKey] = React.useState("reply");
  const {
    conversationData,
    conversationId,
    botId,
    orgId,
    channelId,
    contactId,
    mute,
    contactData,
    fileData,
    filePrivateData,
    uploadFilestatus,
    uploadPrivateFilestatus,
    //reset_fileData,
  } = useSelector((state) => state.chatSettings);
  const { chatFromoneSpocData, todaysChat } = useSelector(
    (state) => state.socketsSlice
  );

  const { contactUpdateData } = useSelector((state) => state.socketsSlice);
  const user = JSON.parse(localStorage.getItem("user"));
  var [chatAssignee, setChatAssignee] = React.useState("");
  var [chatAssigneeCount, setChatAssigneeCount] = React.useState(0);

  var [conData, setConData] = React.useState([]);
  var [chatData, setChatData] = React.useState([]);
  var [chatMsg, setChatMsg] = React.useState("");
  var [chatPrivateMsg, setChatPrivateMsg] = React.useState("");
  var [agent, setAgent] = React.useState("");
  var [file, setFile] = React.useState("");
  var [filePrivate, setFilePrivate] = React.useState("");
  var [fileSize, setFileSize] = React.useState(false);
  var [filePrivateSize, setFilePrivateSize] = React.useState(false);

  const [selectedFile, setSelectedFile] = React.useState();
  const [selectedPrivateFile, setSelectedPrivateFile] = React.useState();
  const [isFilePicked, setIsFilePicked] = React.useState(false);
  const [isFilePickedPrivate, setIsFilePickedPrivate] = React.useState(false);
  const [isOpen, setOpen] = React.useState(false);
  const [process, setProcess] = React.useState("success");
  const [privateProcess, setPrivateProcess] = React.useState("success");
  const ref = React.useRef(null);
  const [progress, setProgress] = React.useState(0);

  const [buffer, setBuffer] = React.useState(10);
  const progressRef = React.useRef(() => {});

  React.useEffect(() => {
    !!uploadFilestatus && setProcess(uploadFilestatus);
    !!uploadFilestatus &&
      uploadFilestatus === "error" &&
      setIsFilePicked(false);
    const setTimeOutFun = async () => {
      await timeOut(2000);
      setProcess("success");
    };
    !!uploadFilestatus && uploadFilestatus === "error" && setTimeOutFun();
  }, [uploadFilestatus]);

  React.useEffect(() => {
    setPrivateProcess(uploadPrivateFilestatus);
  }, [uploadPrivateFilestatus]);

  React.useEffect(() => {
    dispatch(fetchTodayschat());
    setProcess("success");
    handleFileClose();
    handleFilePrivateClose();
  }, [dispatch, conversationId]);

  React.useEffect(() => {
    dispatch(fetchTodayschat());
  }, [dispatch, conversationId, contactUpdateData]);

  React.useEffect(() => {
    // console.log("  mute === true && sendingPlay(); ");
    // mute === true && sendingPlay();
    // sendingPlay();

    setChatAssignee("");
    !!todaysChat &&
      !!todaysChat.data &&
      todaysChat.data.map(
        (item) =>
          item._id === conversationId &&
          parseInt(item.status) === 0 &&
          setChatAssignee(item.chatAssign[0].assignee_id)
      );
  }, [todaysChat, conversationId]);

  // check chat asignee Count
  React.useEffect(() => {
    setChatAssigneeCount([]);
    // setChatMsg("");
    !!todaysChat &&
      !!todaysChat.data &&
      todaysChat.data.map(
        (item) =>
          item._id === conversationId &&
          parseInt(item.status) === 0 &&
          setChatAssigneeCount(item.chatAssign.length)
      );
  }, [todaysChat, conversationId]);

  // CLear Chat Message if Select New Chat
  React.useEffect(() => {
    setChatMsg("");
    setChatPrivateMsg("");
  }, [conversationId]);

  function onClick(emojiData, event) {
    setChatMsg((e) => e !== null && e + emojiData.emoji);
  }

  const handleClose = () => {
    setOpen(false);
  };

  // Close Emoji Picker

  React.useEffect(() => {
    setAgent(JSON.parse(localStorage.getItem("user")));
  }, []);

  //console.log("mute == ", mute);
  React.useEffect(() => {
    !!chatFromoneSpocData &&
      chatFromoneSpocData.sender_type === 1 &&
      mute === true &&
      sendingPlay();
    !!chatFromoneSpocData &&
      chatFromoneSpocData.length !== 0 &&
      setChatData((chatData) => [...chatData, chatFromoneSpocData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatFromoneSpocData]);

  React.useEffect(() => {
    !!conversationData &&
      conversationData.length !== 0 &&
      setConData(conversationData);
    setChatData("");
  }, [conversationData]);

  // React.useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [chatData]);

  // React.useEffect(() => {
  //   bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  // }, [todaysChat]);

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    setIsAtBottom(scrollHeight - scrollTop <= clientHeight + 10);
  };

  React.useEffect(() => {
    const chatArray = Array.isArray(chatData) ? chatData : [];
    const todaysArray = Array.isArray(todaysChat?.data) ? todaysChat.data : [];

    const hasMessages =
      chatArray.some(
        (item) => !!item.data && item.data.conversation_id === conversationId
      ) || todaysArray.some((item) => item._id === conversationId);

    if (hasMessages && isAtBottom) {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatData, todaysChat, conversationId, isAtBottom]);

  React.useEffect(() => {
    setFile(fileData);
  }, [fileData]);

  React.useEffect(() => {
    setFilePrivate(filePrivateData);
  }, [filePrivateData]);

  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  const handleFileClose = () => {
    setFile("");
    setIsFilePicked(false);
  };

  const handleFilePrivateClose = () => {
    setFilePrivate("");
    setIsFilePickedPrivate(false);
  };

  const changePrivateHandler = async (event) => {
    if (parseInt(event.target.files[0].size) > 5242855) {
      setFilePrivateSize(true);
      await timeOut(2000);
      setFilePrivateSize(false);
    } else {
      // dispatch(reset_fileData());
      setFilePrivate("");
      setSelectedPrivateFile();
      setSelectedPrivateFile(event.target.files[0]);
      setIsFilePickedPrivate(true);
      await dispatch(uploadPrivateFileData(event.target.files[0]));
    }
    event.target.value = "";
  };

  const { data: cannedResponses } = useSelector(
    (state) => state.cannedResponses
  );

  React.useEffect(() => {
    dispatch(fetchAllCannedResponses());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendMessage = async (media, mimetype) => {
    var msg = chatMsg;
    var messagePayload = {
      data: {
        flag: "continue",
        channel_id: channelId,
        bot_id: botId,
        org_id: orgId,
        account_id: localStorage.getItem("atua"),
        conversation_id: conversationId,
        agent_id: agent.uid,
        agentName: agent.displayname,
        assign_id: "",
        contact_id: contactId,
        contact: contactData,
        isPrivate: 0,
        message: [
          {
            content_type: 0,
            content: msg,
            media: {
              media_type: isFilePicked === true && !!mimetype ? mimetype : "",
              media_path: isFilePicked === true && !!media ? media : "",
            },
            message_type: isFilePicked === true ? "media" : "text",
          },
        ],
      },
      position: "right",
      sender_type: 0,
    };
    //https://www.shutterstock.com/image-photo/focused-woman-wearing-headphones-using-260nw-1395298487.jpg

    socket.current.emit("chatSentFromApp", messagePayload);
    setChatMsg("");
    localStorage.removeItem(`draft-${conversationId}`); // Remove saved draft
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    //}
  };

  // for child component
  const callStateData = async (data) => {
    setChatMsg(data);
  };

  React.useEffect(() => {
    !!chatMsg && handleSendMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatMsg]);

  const handleSendMessage = async () => {
    if (chatAssigneeCount > 0) {
      callStateData();
      var mimetype =
        !!file && (!!file.mimetype ? file.mimetype.split("/") : "");
      var media = !!file && (!!file.data ? file.data : "");

      if (!!chatMsg && chatMsg.length > 0 && !!media && media.length > 0) {
        await sendMessage(media, mimetype[0]);
      } else if (
        (!!chatMsg && chatMsg.trim() !== "") ||
        (!!media && media.length > 0)
      ) {
        await sendMessage(media, mimetype[0]);
      }
      setSelectedFile("");
      setIsFilePicked(false);
      media = "";
      setFile("");
    }
  };

  const handleSendPrivateMessage = async () => {
    var mimetype =
      !!filePrivate &&
      (!!filePrivate.mimetype ? filePrivate.mimetype.split("/") : "");
    var media = !!filePrivate && (!!filePrivate.data ? filePrivate.data : "");
    //chatPrivateMsg
    if (
      !!chatPrivateMsg &&
      chatPrivateMsg.length > 0 &&
      !!media &&
      media.length > 0
    ) {
      await sendPrivateMessage(media, mimetype[0]);
    } else if (
      (!!chatPrivateMsg && chatPrivateMsg.trim() !== "") ||
      (!!media && media.length > 0)
    ) {
      await sendPrivateMessage(media, mimetype[0]);
    }

    setSelectedPrivateFile("");
    setIsFilePickedPrivate(false);
    media = "";
    setFilePrivate("");
  };
  const sendPrivateMessage = async (media, mimetype) => {
    var msg = chatPrivateMsg;
    var messagePayload = {
      data: {
        flag: "note",
        channel_id: channelId,
        bot_id: botId,
        org_id: orgId,
        account_id: localStorage.getItem("atua"),
        conversation_id: conversationId,
        agent_id: agent.uid,
        agentName: agent.displayname,
        assign_id: "",
        contact_id: contactId,
        contact: contactData,
        message: [
          {
            content_type: 11,
            content: msg,
            media: {
              media_type:
                isFilePickedPrivate === true && !!mimetype ? mimetype : "",
              media_path: isFilePickedPrivate === true && !!media ? media : "",
            },
            message_type: isFilePickedPrivate === true ? "media" : "text",
          },
        ],
      },
      position: "right",
      sender_type: 0,
    };
    socket.current.emit("chatSentFromApp", messagePayload);
    setChatPrivateMsg("");
  };

  // Helper Datetime function here
  const formatDate = (createdAt) => {
    const date = moment.utc(createdAt).add(5, "hours").add(30, "minutes");

    return date.isSame(moment(), "day")
      ? date.format("hh:mm A")
      : date.format("MMM-DD hh:mm A");
  };

  return (
    <>
      <Popover
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        className="App"
      >
        <div className="App">
          <EmojiPicker onEmojiClick={onClick} autoFocusSearch={false} />
        </div>
      </Popover>

      <ChatMessages
        //className="chatoutput-section"
        ref={containerRef}
        onScroll={handleScroll} // 👈 HERE!
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          backgroundColor: "#000 !important", // Adds a semi-transparent white background to mimic opacity
          minWidth: "550px",
          backgroundImage: `url(/static/img/samples/fbe41cd97ada760e7b38de1be18301a5.jpg)`, // Background image
          backgroundSize: "10%", // Ensures the image covers the entire area
          backgroundBlendMode: "overlay", // Blends the transparent color with the image
          backgroundAttachment: "fixed",
          height: "calc(-35px + 68vh)",
          overflowY: "auto",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      >
        {!!conData &&
          conData.length > 0 &&
          conData[0]._id === conversationId &&
          conData[0].chat.map((item, i) =>
            item.sender_type === 1 ? (
              <ChatMessageComponent
                key={i}
                name={!!item && item.chatContact[0].name}
                avatar="/static/img/avatars/avatar-2.jpg"
                message={!!item && item.content}
                // time={
                //   ("0" + new Date(item.created_at).getHours()).slice(-2) +
                //   ":" +
                //   ("0" + new Date(item.created_at).getMinutes()).slice(-2)
                // }
                time={formatDate(item.created_at)}
                position="left"
                content_type={!!item && item.content_type}
                is_media={
                  !!item && (!!item.message_type ? item.message_type : "")
                }
                media_type={
                  !!item && (!!item.media_type ? item.media_type : "")
                }
                media_url={!!item && (!!item.media_path ? item.media_path : "")}
              />
            ) : (
              <ChatMessageComponent
                key={i}
                name={
                  !!item &&
                  (!!item.chatAgent[0]
                    ? item.chatAgent[0].displayname
                    : item.chatAgent[0].name)
                }
                avatar="/static/img/avatars/avatar-2.jpg"
                message={!!item && item.content}
                content_type={!!item && item.content_type}
                // time={
                //   ("0" + new Date(item.created_at).getHours()).slice(-2) +
                //   ":" +
                //   ("0" + new Date(item.created_at).getMinutes()).slice(-2)
                // }
                time={formatDate(new Date(item.created_at))}
                position="right"
                is_media={
                  !!item && (!!item.message_type ? item.message_type : "")
                }
                media_type={
                  !!item && (!!item.media_type ? item.media_type : "")
                }
                media_url={!!item && (!!item.media_path ? item.media_path : "")}
              />
            )
          )}

        {!!chatData &&
          chatData.length !== 0 &&
          chatData.map(
            (item, i) =>
              !!item.data &&
              item.data.conversation_id === conversationId &&
              (item.sender_type === 1 ? (
                <ChatMessageComponent
                  key={i}
                  name={
                    !!item &&
                    !!item.data &&
                    !!item.data.contact &&
                    item.data.contact.name
                  }
                  avatar="/static/img/avatars/avatar-2.jpg"
                  message={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    item.data.message[0].content
                  }
                  // time={
                  //   new Date(Date.now()).getHours() +
                  //   ":" +
                  //   new Date(Date.now()).getMinutes()
                  // }
                  time={formatDate(new Date(Date.now()))}
                  position="left"
                  sender_type={item.sender_type}
                  content_type={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    item.data.message[0].content_type
                  }
                  is_media={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text" ? 0 : 1)
                  }
                  media_type={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text"
                      ? ""
                      : item.data.message[0].media.media_type)
                  }
                  media_url={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text"
                      ? ""
                      : item.data.message[0].media.media_path)
                  }
                />
              ) : (
                <ChatMessageComponent
                  key={i}
                  name={!!item && !!item.data && item.data.agentName}
                  avatar="/static/img/avatars/avatar-2.jpg"
                  message={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    item.data.message[0].content
                  }
                  time={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    formatDate(new Date(item.data.message[0].created_at))
                  }
                  position="right"
                  content_type={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    item.data.message[0].content_type
                  }
                  is_media={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text" ? 0 : 1)
                  }
                  media_type={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text"
                      ? ""
                      : item.data.message[0].media.media_type)
                  }
                  media_url={
                    !!item &&
                    !!item.data &&
                    !!item.data.message &&
                    (item.data.message[0].message_type === "text"
                      ? ""
                      : item.data.message[0].media.media_path)
                  }
                />
              ))
          )}

        <div ref={bottomRef} />
      </ChatMessages>
      <div className="chatinput-section">
        <Divider sx={{ borderBottomWidth: 2 }} />

        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          <Tab
            eventKey="reply"
            title="Reply"
            style={{ backgroundColor: "#fff" }}
          >
            {!!process && process === "loading" && (
              <LinearProgress
                my={2}
                variant="buffer"
                value={progress}
                valueBuffer={buffer}
                color="success"
              />
            )}
            {isFilePicked && (
              <ChatInput container className="attachedFile-section">
                <div className="attached-File">
                  {selectedFile.name}
                  <CloseIcon
                    style={{ marginLeft: "50px" }}
                    onClick={
                      !!process && process === "success" && handleFileClose
                    }
                  />
                </div>
              </ChatInput>
            )}
            {fileSize && (
              <Alert mb={4} severity="error">
                The file is too large. The total size is more than 5MB!
              </Alert>
            )}
            {!!process && process === "error" && (
              <Alert mb={4} severity="error">
                {!!fileData && fileData.message}
              </Alert>
            )}
            <ChatInputComponent
              user={user}
              process={process}
              chatAssignee={chatAssignee}
              chatAssigneeCount={chatAssigneeCount}
              handleSendMessage={handleSendMessage}
              callStateData={callStateData}
              setFileSize={setFileSize}
              setFile={setFile}
              setSelectedFile={setSelectedFile}
              setIsFilePicked={setIsFilePicked}
              channelId={channelId}
              uploadFileData={uploadFileData}
              cannedResponses={cannedResponses}
              isFilePicked={isFilePicked}
              ml={2}
              mt={2}
              conversationId={conversationId}
            />
          </Tab>
          {!!chatAssigneeCount && chatAssigneeCount > 1 ? (
            <Tab
              eventKey="note"
              title="Note"
              style={{ backgroundColor: "#fff" }}
            >
              {!!privateProcess && privateProcess === "loading" && (
                <LinearProgress
                  my={2}
                  variant="buffer"
                  value={progress}
                  valueBuffer={buffer}
                  color="warning"
                />
              )}
              {isFilePickedPrivate && (
                <ChatInput container>
                  {selectedPrivateFile.name}
                  <CloseIcon
                    style={{ marginLeft: "50px" }}
                    onClick={handleFilePrivateClose}
                  />
                </ChatInput>
              )}
              <ChatInput container>
                <Grid item style={{ flexGrow: 1 }}>
                  <TextField
                    variant="outlined"
                    label="Type your message"
                    fullWidth
                    onChange={(e) => setChatPrivateMsg(e.target.value)}
                    value={chatPrivateMsg}
                    onKeyDown={(e) => {
                      e.keyCode === 13 && handleSendPrivateMessage();
                    }}
                  />
                </Grid>
              </ChatInput>
              <ChatInput container>
                <Grid item style={{ flexGrow: 1 }}>
                  <Box ml={2} mt={2} className="chatButtons">
                    <ChatActionNote>
                      <input
                        style={{ display: "none" }}
                        id="raised-button-filePrivate"
                        accept=".mp3,.doc,.pdf,.mpeg,.mp4,.csv,.xls,.xlsx"
                        //multiple
                        type="file"
                        // onChange={(e) => setFiles(e.target.files[0])}
                        onChange={changePrivateHandler}
                      />
                      <label htmlFor="raised-button-filePrivate">
                        <AttachmentIcon htmlFor="raised-button-filePrivate" />
                      </label>
                    </ChatActionNote>
                  </Box>
                </Grid>
                <Grid item>
                  <Box ml={2}>
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={() => {
                        handleSendPrivateMessage();
                      }}
                    >
                      Send
                    </Button>
                  </Box>
                </Grid>
              </ChatInput>
            </Tab>
          ) : (
            !!chatAssignee &&
            chatAssignee === user.uid && (
              <Tab
                eventKey="note"
                title="Note"
                style={{ backgroundColor: "#fff" }}
              >
                {!!privateProcess && privateProcess === "loading" && (
                  <LinearProgress
                    my={2}
                    variant="buffer"
                    value={progress}
                    valueBuffer={buffer}
                    color="warning"
                  />
                )}
                {isFilePickedPrivate && (
                  <ChatInput container>
                    {selectedPrivateFile.name}
                    <CloseIcon
                      style={{ marginLeft: "50px", cursor: "pointer" }}
                      onClick={
                        !!privateProcess &&
                        privateProcess === "success" &&
                        handleFilePrivateClose
                      }
                    />
                  </ChatInput>
                )}
                {filePrivateSize && (
                  <Alert mb={4} severity="error">
                    The file is too large. The total size is more than 5MB!
                  </Alert>
                )}
                <ChatInput container style={{ marginBottom: "15px" }}>
                  <Grid item style={{ flexGrow: 1 }}>
                    <TextField
                      variant="outlined"
                      label="Type your message"
                      fullWidth
                      id="txtchatPrivateMsg"
                      multiline
                      rows={2}
                      onChange={(e) => setChatPrivateMsg(e.target.value)}
                      value={chatPrivateMsg}
                      onKeyDown={(e) => {
                        if (
                          !!privateProcess &&
                          privateProcess === "success" &&
                          e.keyCode === 13 &&
                          !e.shiftKey // Send message on Enter without Shift
                        ) {
                          e.preventDefault(); // Prevent the default behavior of Enter
                          handleSendPrivateMessage();
                        }
                        if (e.key === "Enter" && e.shiftKey) {
                          // Prevent the default behavior of the Enter key
                          e.preventDefault();
                          // Add a newline character to the input value
                          setChatPrivateMsg(chatPrivateMsg + "\n");
                        }
                      }}
                    />
                  </Grid>
                </ChatInput>
                <ChatInput container>
                  <Grid item style={{ flexGrow: 1 }}>
                    <Box ml={2} mt={2} className="chatButtons">
                      {!!privateProcess && privateProcess === "success" ? (
                        <ChatActionNote>
                          <input
                            style={{ display: "none" }}
                            id="raised-button-filePrivate"
                            accept=".mp3,.doc,.pdf,.mpeg,.mp4,.csv,.xls,.xlsx"
                            multiple
                            type="file"
                            // onChange={(e) => setFiles(e.target.files[0])}
                            onChange={changePrivateHandler}
                          />

                          <label htmlFor="raised-button-filePrivate">
                            <AttachmentIcon htmlFor="raised-button-filePrivate" />
                          </label>
                        </ChatActionNote>
                      ) : (
                        <ChatActionNote>
                          <AttachmentIcon htmlFor="raised-button-filePrivate" />
                        </ChatActionNote>
                      )}
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box ml={2}>
                      <Button
                        variant="contained"
                        color="warning"
                        onClick={() => {
                          !!privateProcess &&
                            privateProcess === "success" &&
                            handleSendPrivateMessage();
                        }}
                      >
                        Send
                      </Button>
                    </Box>
                  </Grid>
                </ChatInput>
              </Tab>
            )
          )}
        </Tabs>
      </div>
    </>
  );
};

export default ChatMessagePannel;
